import Head from "next/head";
import BookaVisit from "../src/components/pages/BookaVisit";
const nextBookaVisit = ({ tourForm, tourFormToggle }) => {
  return (
    <>
      <Head>
        <title>Book an office tour of our available work spaces - Garden Office Bermondsey</title>
        <meta name="description" content="Book a tour at Garden Office Bermondsey in London and discover our facilities, workspaces, and meeting rooms to see if they suit your business. Explore now!" />
        <meta itemProp="name" content="description" />
        <meta itemProp="description" content="description" />
        <meta itemProp="image" content="image" />
      </Head>

      <BookaVisit tourForm={tourForm} tourFormToggle={tourFormToggle} />
    </>
  );
};

export default nextBookaVisit;
